module.exports = __webpack_public_path__ + "KaTeX_Main-Regular.f454cf43.ttf";